import { InfographicSize } from "../model/infographic-size.enum";
import PREVIEW_16_9 from "../assets/images/preview-16-9.png";
import PREVIEW_9_16 from "../assets/images/preview-9-16.png";
import PREVIEW_1_1 from "../assets/images/preview-1-1.png";
import PREVIEW_POSTER from "../assets/images/preview-poster.png";

export const sizeRadioOptions = [
    { value: InfographicSize.RATIO_16_9, src: PREVIEW_16_9 },
    { value: InfographicSize.RATIO_9_16, src: PREVIEW_9_16 },
    { value: InfographicSize.RATIO_1_1, src: PREVIEW_1_1 },
    { value: InfographicSize.POSTER, src: PREVIEW_POSTER },
    { value: InfographicSize.A4, src: PREVIEW_POSTER },
    { value: InfographicSize.A3, src: PREVIEW_POSTER },
];

export const sizeImageSrc = {
    [InfographicSize.RATIO_16_9]: PREVIEW_16_9,
    [InfographicSize.RATIO_9_16]: PREVIEW_9_16,
    [InfographicSize.RATIO_1_1]: PREVIEW_1_1,
    [InfographicSize.A4]: PREVIEW_POSTER,
    [InfographicSize.A3]: PREVIEW_POSTER,
    [InfographicSize.POSTER]: PREVIEW_POSTER,
};